module.exports = __webpack_public_path__ + "img/Fond_Carte_Sulimo_XS_Neutre.ed877c49.png";